// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-right[data-v-6621101e]{border-right:2px solid #333}.temperature[data-v-6621101e]{font-size:.75rem;white-space:nowrap}.date[data-v-6621101e]{font-size:.95rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
